"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _DisconnectedBody = require("./DisconnectedBody.styled");
var DisconnectedMediaBody = function DisconnectedMediaBody() {
  return /*#__PURE__*/_react["default"].createElement(_DisconnectedBody.DisconnectedBackground, null, /*#__PURE__*/_react["default"].createElement(_DisconnectedBody.DisconnectedIconBackground, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faExclamationTriangle
  })), /*#__PURE__*/_react["default"].createElement(_DisconnectedBody.DisconnectedText, null, "Connection Lost"));
};
var _default = exports["default"] = DisconnectedMediaBody;